<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button
      (click)="dismissDialog()"
      color="secondary"
      fill="outline"
      >
      <ion-icon name="arrow-back" />
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>
  <ion-title id="jobDetailTitle" role="heading" aria-level="2">{{ 'TITLE.jobDetails' | translate }}</ion-title>
</ion-toolbar>

<ion-content>
  <div class="ride">
    <route-event-card [data]="job" [preview]="true" [headerLevel]="3" [tapForDetails]="false" />

    @if (job.dropoff; as dropoff) {
      <section class="card route-event card-dropoff {{ dropoff.type }}">
        <div class="header">
          <h3 class="title">{{ 'LABEL.scheduled' | translate }} {{ dropoff.headerInfo.type | translate }}: </h3>
          @if (dropoff.headerInfo.time) {
            <time [ngClass]="{ 'late': dropoff.isLate }">{{ dropoff.headerInfo.time }}</time>
          }
        </div>
        <div class="content">
          @if (dropoff.location) {
            <app-address
              [location]="dropoff.location"
              [phoneNumber]="dropoff.phoneNumber"
              />
          }
        </div>
      </section>
    }
  </div>

  <div class="image-comments">
    @if (job.value.riderImageId) {
      <section class="card rider-image">
        <h3 class="card-title">{{ 'LABEL.riderImage' | translate }}</h3>
        <figure>
          @if ({ riderImage: riderImage$ | async }; as $) {
            @if ($.riderImage) {
              <img width="200" height="200" [src]="$.riderImage" aria-label="">
            }
            @if (!(hasNetwork$ | async) && !$.riderImage) {
              <figcaption>{{ 'MESSAGE.imageOffline' | translate }}</figcaption>
            }
          }
        </figure>
      </section>
    }

    <div class="comments">
      @if (job.value.rideComments) {
        <section class="card">
          <h3 class="card-title">{{ 'LABEL.reservationSpecialDir' | translate }}</h3>
          <p class="comments">{{ job.value.rideComments }}</p>
        </section>
      }

      @if (job.value.riderComments) {
        <section class="card">
          <h3 class="card-title">{{ 'LABEL.riderSpecialDir' | translate }}</h3>
          <p class="comments">{{ job.value.riderComments }}</p>
        </section>
      }
    </div>

  </div>

  <section class="card details">
    <dl>
      @if (job.riderName) {
        <dt>{{ 'LABEL.riderName' | translate }}</dt>
        <dd>{{ job.riderName }}</dd>
      }

      <dt>{{ 'LABEL.fare' | translate }}</dt>
      <dd>{{ fare }}</dd>

      <dt>{{'LABEL.riderPhone' | translate}}</dt>
      <dd>
        @if (job.value.riderPhone) {
          <a [href]="'tel:+1' + job.value.riderPhone">{{ job.value.riderPhone }}</a>
        }
      </dd>

      <dt>{{ 'LABEL.account' | translate }}</dt>
      <dd>{{ job.value.accountCode }}</dd>

      <dt>{{ 'LABEL.auth' | translate }}</dt>
      <dd>{{ job.value.authNumber }}</dd>

      @if (features.showClientId) {
        <dt>{{ 'LABEL.clientId' | translate }}</dt>
        <dd>{{ job.value.riderId }}</dd>
      }

      <dt>{{ translationKeys.scheduledTime | translate }}</dt>
      <dd>{{ job.headerInfo.time }}</dd>

      @if (scheduleWindow) {
        <dt>{{ (jobType.Pickup === job.value.jobType ? 'LABEL.pickupWindow' : 'LABEL.dropoffWindow') | translate }}</dt>
        <dd>{{ scheduleWindow }}</dd>
      }

      <dt>{{ translationKeys.priority | translate }}</dt>
      <dd>{{ priorityTime }} {{ job.value.priority }}</dd>

      @if (features.hasChildren || features.hasEscorts || features.hasAdditionalPassengerCount) {
        <dt>{{ 'LABEL.additionalPassengers' | translate }}</dt>
        <dd>
          @if (features.hasAdditionalPassengerCount) {
            {{ job.value.additionalRideCount || 0 }}
          }
          @if (!features.hasAdditionalPassengerCount) {
            {{ (job.value.numberOfChildren || 0) + (job.value.escorts || job.value.companions || 0) }}
          }
          <small>
            @if (features.hasChildren) {
              <br>{{ 'LABEL.children' | translate }}: {{ job.value.numberOfChildren || 0 }}
              }
              @if (features.hasEscorts) {
                <br> {{ 'LABEL.escorts' | translate }}: {{ job.value.escorts || job.value.companions || 0 }}
                }
              </small>
            </dd>
          }

          @if (job.value.ambulatorySeats) {
            <dt>{{ 'LABEL.ambulatorySeats' | translate }}</dt>
            <dd>{{ job.value.ambulatorySeats }}</dd>
          }

          @if (job.value.wheelchairSeats) {
            <dt>{{ 'LABEL.wheelchairStations' | translate }}</dt>
            <dd>{{ job.value.wheelchairSeats }}</dd>
          }

          @if (job.location.note) {
            <dt>{{ (jobType.Pickup === job.value.jobType ? 'NOTES.pickup' : 'NOTES.dropoff') | translate }}</dt>
            <dd>{{ job.value.note }}</dd>
          }

          @if (job.value.driverNote) {
            <dt>{{ 'NOTES.driver' | translate }}</dt>
            <dd>{{ job.value.driverNote }}</dd>
          }

        </dl>
      </section>



    </ion-content>

    <ion-toolbar class="bottom-actions">
      <ion-button type="button" fill="outline" expand="block" (click)="dismissDialog()">{{ 'ACTION.close' | translate }}</ion-button>
    </ion-toolbar>
